var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-midnight"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12 5.73a.367.367 0 0 0 0 .543l3.19 3.19c.16.16.415.16.542 0l.638-.638c.16-.128.16-.383 0-.543L2.863 6.783h8.754A.388.388 0 0 0 12 6.4v-.765a.369.369 0 0 0-.383-.383H2.863L4.49 3.72c.16-.16.16-.414 0-.542l-.638-.638c-.127-.16-.383-.16-.542 0L.12 5.73z",
    fill: "currentColor"
  })));
};

export default SvgBackArrow;